import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=30f07938&"
import script from "./StatsView.vue?vue&type=script&lang=js&"
export * from "./StatsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports